// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__YkOIv","col":"styles_col__VVLsH"};